// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__qYKzV","label":"Category_label__1fOPz","content":"Category_content__M3Mvw","header":"Category_header__2B9pE","location":"Category_location__m_swh"};